import React from "react";
import Icon from "@mdi/react";
import { mdiMagnify, mdiCog, mdiAlertCircle } from "@mdi/js";
import Modal from "components/Modal";

type StatusMapping = {
  [key: string]: {
    text: string;
    alertType: string;
    icon: string;
    color: string;
  };
};

interface Props {
  onboardingStatus: string;
  statusMapping: StatusMapping;
  open: boolean;
  closeHandler: () => void;
}

const StripeAccountStatusCard: React.FC<Props> = ({
  onboardingStatus,
  statusMapping,
  open,
  closeHandler
}) => {
  const currentStatus = statusMapping[onboardingStatus];
  return (
    <Modal
      isOpen={open}
      closeModal={closeHandler}
      isDisableCloseModal
      wrapperClass="!my-auto desktop:!min-h-fit text-sm"
      dialogClass="!bg-foreground !p-6 desktop:!p-10 !border !border-card !overflow-y-auto gap-2.5 mx-auto"
      closeClass="!hidden">
      <div className="min-w-[300px] min-h-[30%] text-center flex justify-center items-center p-6">
        <div className="flex flex-col items-center w-full">
          <Icon
            path={
              currentStatus?.icon === "find_in_page"
                ? mdiMagnify
                : currentStatus?.icon === "settings_applications"
                  ? mdiCog
                  : mdiAlertCircle
            }
            size={4}
            className={currentStatus?.color || "text-gray-500"}
          />
          <p className={`mt-4 p-4 text-xl ${currentStatus?.color || "text-gray-500"}`}>
            {currentStatus?.text}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default StripeAccountStatusCard;
